export default "__VITE_ASSET__BDRQeMYL__"